import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {DDPTInfo} from "../model/DDPTInfo";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) {
  }

  ddptInfoUrl = environment.apiUrl + '/v1/ticketInfo/public/getTicketInfo/dpk'

  ddptImagesUrl = environment.apiUrl +  '/v1/ticketInfo/public/getTicketImages/dpk'

  ddptListUrl = environment.apiUrl +  '/v1/ticketInfo/public/getDPKList'

  getDDPTInfo(ddpkId: number, companyOid: number) {
    const params = new HttpParams()
      .set('companyOid', companyOid)
      .set('ddptOid', ddpkId)

    const url = `${this.ddptInfoUrl}`;

    return this.http.get<DDPTInfo>(url, {params});
  }

  getImages(ddpkId: string, companyOid: string) {
    const params = new HttpParams()
      .set('companyOid', companyOid)
      .set('ddptOid', ddpkId)

    const url = `${this.ddptImagesUrl}`;

    return this.http.get<any>(url, {params});
  }

  getDPKList(oib: string, companyOid: string, licensePlate: string) {

    licensePlate = licensePlate
      .replace(/Ž/g, 'Z')
      .replace(/Đ/g, 'D')
      .replace(/Š/g, 'S')
      .replace(/Č/g, 'C')
      .replace(/Ć/g, 'C');

    const params = new HttpParams()
      .set('oib', oib)
      .set('companyOid', companyOid)
      .set('licensePlate', licensePlate);

    return this.http.get<DDPTInfo[]>(this.ddptListUrl, { params });
  }


}
